import React from 'react'
import PropTypes from 'prop-types'

const Form = ({ children, onSubmit, className, autoOff }) => {
  return (
    <form onSubmit={onSubmit} className={className} autoComplete={autoOff ? 'off' : 'on'}>
      { children }
    </form>
  )
}

export default Form

Form.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.array,
    PropTypes.element
  ]),
  autoOff: PropTypes.bool,
  onSubmit: PropTypes.func,
  className: PropTypes.any
}
